/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Cookies from "js-cookie";

const getRSessionId = () => {
  const handleSessionId = () => {
    let time = (new Date).getTime();
    const e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
      const a = (time + 16 * Math.random()) % 16 | 0;
      return time = Math.floor(time / 16), ("x" === e ? a : 3 & a | 8).toString(16);
    });
    return e;
  };

  if (!Cookies.get("rsessionid")) {
    Cookies.set("rsessionid", handleSessionId());
  }

  const rSession = Cookies.get("rsessionid");
  return rSession || "";
};

export default getRSessionId;
